import { AsignUserRoleService } from './../../shared/services/asign-user-role.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { AccessManagementPopupComponent } from './access-management-popup/access-management-popup.component';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';

@Component({
    selector: 'app-access-management',
    templateUrl: './access-management.component.html',
    styleUrls: ['./access-management.component.scss'],
    standalone: false
})

export class AccessManagementComponent implements OnInit {

  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnDefs;

  rowClassRules;

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  pageSize;

  components: any;

  overlayNoRowsTemplate;

  listObjectDropDown: any = [];

  dynamicData = [];

  trnxScreenId;

  ngModelObject = [];

  ngModelObjectDivision = [];

  bootstrapColumn = 0;

  //dropDowns = [];

  retrieveObject: any = [];

  headerNameHtml = '';
3
  buttonName;


  tableID = '';

  agGridShow = false;

  retrieveNgModelCreation: any = [];

  screenType;

  value;

  buttonIdList: any = [];

  recordsStart = 0;

  screenTypeTOrM = '';

  backgroundColorScreen = '';

  backgroundColorButton = '';

  isdisable: boolean = false;

  getData: any = [];

  userData:any=[];

  roleData:any=[];
  comapanyId;
  dnsid:number;
  importExportTableName = "dns_userlist";
  

  //constructor
  constructor(
    private dialog: MatDialog, private commonService: CommonService, private localStorage: LocalStorageSettingsService,private asignUserRoleService:AsignUserRoleService,
    private snackBar:MatSnackBar,private spinner:NgxUiLoaderService,private userRoutingModule: UserRoutingModule,
        private reportLinkService:ReportlinksserviceService
  ) {
    this.components = {

      buttonRenderer: Actionbutton,

    };

  }

  async ngOnInit() {

    /* @added by Chandra R
        @date 01-01-2025
        @@desc Below code enable and disable the buttons  in UI based on permission
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorage.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };
    
    this.columnDefs = [
      {
        headerName: 'Action',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
           delete: this.deleteIcon.bind(this)
        },
        pinned: 'left',
        lockPinned: true,
        width: 150,
      },

      {
        headerName: 'WorkspaceId',
        headerTooltip: 'WorkspaceId',
        tooltipValueGetter: (params) =>
          'WorkspaceId : ' + params.value,
        field: 'dnsId',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Company Name',
        headerTooltip: 'Company Name',
        tooltipValueGetter: (params) =>
          'Company Name : ' + params.value,
        field: 'compname',
        filter: 'agTextColumnFilter',
        width: 370,
      }, {
        headerName: 'Workspace Name',
        headerTooltip: 'Workspace Name',
        tooltipValueGetter: (params) =>
          'Workspace Name : ' + params.value,
        field: 'dnsName',
        filter: 'agTextColumnFilter',
        width: 370,
      },

      {
        headerName: 'User Name',
        headerTooltip: 'User Name',
        tooltipValueGetter: (params) =>
          'User Name : ' + params.value,
        field: 'username',
        filter: 'agTextColumnFilter',
        width: 650,
      }

     

    ];
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");

    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    const tenantId = localStorage.getItem("dnsName");
  this.dnsid = Number(tenantId);

  }

  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridAPI.paginationGetTotalPages();

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    /*this.recordsStart = this.recordsStart + 100;

    this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

    console.log(this.retrieveObject);

    if (this.retrieveObject.length == 0) {

      this.recordsStart = this.recordsStart - 100;

    }

    else {

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    /*if (this.recordsStart > 0) {

      this.recordsStart = this.recordsStart - 100;

      this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

      console.log(this.retrieveObject);

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }

  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    this.gridAPI = params.api;
    // this.gridAPI.setGridOption('paginationPageSize', 10)
    this.getData = [];
    this.gridColumnAPI = params.columnApi;

    this.retrieveAssignUsersRoleByDnsId();
    this.retrieveLogedInUser();



  }
  customArray=[];

  //retrieve Assign Users Role By DnsId
  retrieveAssignUsersRoleByDnsId(){
    this.customArray=[];
    var dnsId = localStorage.getItem('WorkspaceId');
    this.commonService.retrieveDnsUserAcessRecord(parseInt (dnsId)).subscribe(response=>
      {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        }
        else {
         
          
          for (const item of response) {
            const usernamesArray = item.userNames.map((user) => user.userName).join(', ');
            const userids = item.userNames.map((user) => user.userid);
            const customObject = {
              dnsId: item.dnsId,
              dnsName: item.dnsName,
              username: usernamesArray,
              userid: userids,
              compname:item.compname,
              companyid:item.companyid
            };
            console.log(customObject);
           this.customArray.push(customObject);
          }
    
          console.log(this.customArray);
        

          this.spinner.stop();
         
          console.log(response);
          console.log(response.data);
          this.gridAPI.setGridOption('rowData', this.customArray);

        }
      }
    );
  }
  retrieveLogedInUser(){
    this.customArray=[];
    var userId = localStorage.getItem('UserId');
    this.commonService.retrieveLogInUser(parseInt (userId)).subscribe(response=>
      {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        }
        else {
          this.comapanyId=response[0].companyid;
          if(this.comapanyId!=1){
            this.isdisable=true;
          }
        
          console.log(response);
    
          console.log(this.comapanyId);
        


        }
      }
    );
  }

  retrieveChildData(e) {
   
    

    // console.log(e);

    // let rowData = e.data;

    // console.log(rowData);


    // var obj = {
   
    //   "userid": e.data.userid,
    //   "roleid": e.data.roleid,
  
    // }
    // let dialogRef = this.dialog.open(AccessManagementPopupComponent, {
    //   panelClass: 'custom-dialog-container-materialFulfilment',
    //   width: '55%',
    //   autoFocus: false,
    //   data: { edata: obj},
    //   disableClose: true,
    // });

    // dialogRef.afterClosed().subscribe(result=>{
    //   this.retrieveAssignUsersRoleByDnsId();
    // })


  }
/*
  Author-Abhishek T
  10-10-2023
  for checking the access for user and openning the edit popup
*/
  // Aggrid Edit function
  editIcon(e) {
    if(this.comapanyId!=1){
      var userId = localStorage.getItem('UserId');
      let  flag:boolean=false;
      for(let i=0;i<e.rowData.userid.length; i++){
          if(userId==e.rowData.userid[i]){
            flag=true;
               break;
          }
      }
      console.log(flag);
      if(!flag){
        this.snackBar.open("You don't have access to perform this action", "OK", {duration: 5000});
        return;
      }

    }

    

    let rowData = e.rowData;

    console.log(rowData);

    var obj = {
      "dnsId":e.rowData.dnsId,
      "userid":e.rowData.userid,
      "username": e.rowData.username,
      "companyid":e.rowData.companyid
    }
    console.log(obj)
    let dialogRef = this.dialog.open(AccessManagementPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result=>{
      this.retrieveAssignUsersRoleByDnsId();
    })

  }
/*
  Author-Abhishek T
  10-10-2023
  for delete the sele ted Access management record
*/
  async deleteIcon(e) {
    var dnsId =e.rowData.dnsId
    console.log(e.rowData.dnsId);
    console.log(this.comapanyId);
    if(this.comapanyId!==1){
      this.snackBar.open("You don't have access to perform this action", "OK", {duration: 5000});
      return;
    }

    if (confirm("Are you sure you want to delete the record ?") == true) {

      (await this.commonService.deleteRecordAccess(dnsId+"")).subscribe(response => {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", {duration: 5000});

        } else {

          this.spinner.stop();
          this.retrieveAssignUsersRoleByDnsId();
          this.snackBar.open(response.statusMessage, "OK", {duration: 50000});
        }
      })
    }
  }

/*
  Author-Abhishek T
  10-10-2023
  for oprnning the add record pop-up
*/
  openSaveForm(buttonName) {
 console.log(this.comapanyId);
    if(this.comapanyId!==1){
      this.snackBar.open("You don't have access to perform this action", "OK", {duration: 5000});
      return;
    }
    console.log(this.listObjectDropDown);
    this.buttonName = buttonName;

    let width = '80%';

    if (this.bootstrapColumn == 1) {

      width = '55%';

    }
    var obj={}
    let dialogRef = this.dialog.open(AccessManagementPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      this.retrieveAssignUsersRoleByDnsId();


    });
  }


          /*
      * Author: Sujeet Sharma
      * Date: 26-12-2025
      *
      * Description:
      * Enhanced Import/Export functionality to support Administration-level
      */
   importData() {
       
          console.log("<--- Inside upload Group Template --->")
          let width = "85%";
        let dialogRef = this.dialog.open(ImportJsonComponent, {
            maxWidth: "70vw",
            height: "50%",
            width: width,
          data: { "tablename": this.importExportTableName, "tenantid": this.dnsid },
            disableClose: true,
          });
        
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
        console.log("tenantid");
            //this.reportCreationData = result;
        
            //this.vaultObjectService.retrieveobjectgroup();
          });
        
        
      }
      
    
      async exportData() {
        this.snackBar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
        let tenantid = localStorage.getItem("dnsName")
       
    
          try {
            const blob = await this.commonService.downloadJsonFile(this.importExportTableName, this.dnsid+"");
            const link = document.createElement('a');
            const timestamp = new Date().getTime();
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.importExportTableName}_export_${timestamp}.json`;
            link.click();
            window.URL.revokeObjectURL(link.href);
    
          } catch (error) {
            console.error('Error downloading JSON:', error);
          }
        
        
      }

}